// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__FBdi-","container":"nav_container__22ked","logo":"nav_logo__BA59c","btnCreatePokemon":"nav_btnCreatePokemon__x-T8u"};